import { Set, Map } from 'immutable';
import { tap, filter } from 'rxjs/operators';
import { generateUUID } from '@famly/vet_ts-utils_generate-uuid';
let actionMap = Map();
export const updateOnActionsEpic = (action$, state$) => action$.pipe(tap(action => {
    const filteredMap = actionMap.filter(({ actionsSet }) => actionsSet.includes(action.type));
    filteredMap.forEach(({ callback }) => callback(action, state$.value));
}), 
// Filter so we don't dispatch anything,
// but can still subscribe to it in the root epic
filter(() => false));
export const subscribe = (actionTypes, callback, idPrefix, idToUse) => {
    if (!Array.isArray(actionTypes) || actionTypes.length === 0) {
        throw Error('updateOnActions must be given at least one action type to reload on');
    }
    if (!callback || typeof callback !== 'function') {
        throw Error('updateOnActions must be given at a function to call on actions');
    }
    const id = idToUse || `${idPrefix}${generateUUID()}`;
    const actionsSet = Set(actionTypes);
    actionMap = actionMap.set(id, {
        actionsSet,
        callback,
    });
    return id;
};
export const subscribeToStore = (actionTypes, callback, idPrefix, idToUse) => {
    const id = subscribe(actionTypes, callback, idPrefix, idToUse);
    return () => unsubscribe(id);
};
export const unsubscribe = (id) => {
    if (id) {
        actionMap = actionMap.remove(id);
    }
};
